module.exports = __webpack_public_path__ + "img/icon-left.f1521cbe.svg";